import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cb74ce0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "card-current-controls"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }

import TicketCard from '@/components/Workspaces/tickets/_spec/TicketCard.vue';
import TaskBlockAssignComponent from '@/components/Workspaces/tickets/tasks/_spec/TaskBlockAssignComponent.vue'
import { PersonRmodel } from '@/app.context/workspace/person.rmodel';
import { useAppContext } from '@/app/_tech';
import sys from '@/sys';
import { computed, reactive, ref, watch } from 'vue';
import { Resolution } from '@/logic/workspaces/tickets/_def';
import { TodoRmodel } from '@/app.context/workspace/tickets/todo.rmodel';
import TicketSlot from '@/components/Workspaces/persons/_spec/TicketSlot.vue'
import * as todoProcessor from '@/ops/workspaces/tickets/todo.processor'
import { TicketAccessLevel } from '@/controllers/workspaces/user.controller.workspace';
import { TodoUiElementController } from '@/components/Workspaces/todos/_spec/todo.controller.basic'
import * as ticketProcessor from '@/ops/workspaces/ticket.processor'



export default /*#__PURE__*/_defineComponent({
  __name: 'TicketStand',
  props: {
    person: {},
    persons: {},
    level: {},
    upcoming: {},
    highlight: { type: Boolean }
  },
  emits: ['updated', 'operation'],
  setup(__props: any, { emit: __emit }) {

const currentTodoItem = computed(()=>person_model.value.current!)

const props = __props


const blockAssigningComponent = ref<InstanceType<typeof TaskBlockAssignComponent> | null>(null)


const emit = __emit

const data:
    {
        operation: string | null,
        level: TicketAccessLevel

    } = reactive({ operation: null, blocker: false, todo_upcoming: props.upcoming, blockers: [], level: props.level ?? TicketAccessLevel.None })

watch(() => data.operation, () => {

    emit('operation', data.operation)
})

const person_model = computed(() => props.person)

const context = useAppContext()

const todoUiController = TodoUiElementController(context)

const derivativeTask = computed(() => { return person_model.value.current?.isDerivative() ?? null })



function onNextClick() {

    if (data.operation) {

        switch (data.operation!) {

            case 'Complete': resolve(Resolution.Done); break;
            case 'Block': block(); break;
            case 'Fail': resolve(Resolution.Failed); break;

            default: sys.warn(`/workspaces/person Unknown operation: ${data.operation}`)
        }

        resetCustomNextTodo();
    }
    else sys.warn(`/workspaces/person Operation is null while 'next' button cliked`)
}

// -- SHARED -- END --//

function onCancelClick() {

    resetCustomNextTodo();
}

function resetCustomNextTodo() {
    data.operation = null
    

    blockAssigningComponent?.value?.reset()

    emit('operation', null)
}

function resolve(resolution: Resolution) {

    if (context.cursor.person == null) Error('Person is null while resolution')

    var person = context.cursor.person!;

    if (person.current == null) sys.warn("Current todo item is null");
    else {
        const t = person.current;

        todoProcessor.todo_resolve(context, t, resolution, props.upcoming ?? undefined)

        //todo later creating of verifications should be assigned here

        emit('updated')
    }
}

/**
* Block or paause
*/
function block() {

    const blocking = blockAssigningComponent?.value!.data() ?? { impersonal: false, persons: [], workable: false };

    const todo = person_model.value.current!

    if (!todo.isDerivative()) {

        todoProcessor.block(context, person_model.value.current!, blocking, true, props.upcoming ?? undefined)
    }
    else todoProcessor.todo_delay(context, todo, props.upcoming ?? undefined)
}

return (_ctx: any,_cache: any) => {
  return (data.operation == null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(TicketSlot, { person_model: person_model.value }, {
          default: _withCtx(() => [
            _createVNode(TicketCard, {
              class: _normalizeClass(["card-current", {'highlight': props.highlight ?? false}]),
              todo: currentTodoItem.value,
              level: data.level,
              "circled-x": true,
              onPerson: _cache[0] || (_cache[0] = (person, index) => _unref(todoUiController).person(currentTodoItem.value, person, index)),
              onBlock: _cache[1] || (_cache[1] = (b)=>_unref(todoUiController).block(b)),
              onX: _cache[2] || (_cache[2] = ($event: any) => (_unref(todoUiController).close(currentTodoItem.value))),
              onV: _cache[3] || (_cache[3] = ($event: any) => (_unref(todoUiController).check(currentTodoItem.value))),
              onCommand: _cache[4] || (_cache[4] = (command)=>ticketProcessor.commandSubmitOnTicket2(_unref(context), command, currentTodoItem.value.ticket))
            }, null, 8, ["class", "todo", "level"])
          ]),
          _: 1
        }, 8, ["person_model"]),
        (data.level >= _unref(TicketAccessLevel).Normal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("button", {
                class: "card-current-op",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (data.operation = 'Complete'))
              }, [
                (derivativeTask.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" Resolve")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("Complete")
                    ], 64))
              ]),
              _createElementVNode("button", {
                class: "card-current-op",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (data.operation = 'Block'))
              }, [
                (derivativeTask.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" Pause")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("Snooze")
                    ], 64))
              ]),
              _createElementVNode("button", {
                class: "card-current-op",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (data.operation = 'Fail'))
              }, [
                (derivativeTask.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" Decline")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("Fail")
                    ], 64))
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        (data.operation == 'Block' && !person_model.value.current!.isDerivative())
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(TaskBlockAssignComponent, {
                ref_key: "blockAssigningComponent",
                ref: blockAssigningComponent,
                task: person_model.value.current!.task,
                persons: props.persons,
                "workable-option-enabled": false,
                "workable-initial-value": false
              }, null, 8, ["task", "persons"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", { onClick: onNextClick }, "Next"),
        _createTextVNode(),
        _createElementVNode("button", { onClick: onCancelClick }, "Cancel")
      ]))
}
}

})